function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 120,
    height: 80,
    rx: 4,
    ry: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.38,
    y: 21.01,
    width: 23.25,
    height: 37.98,
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.77,40c0-7.41,3.4-14.41,9.22-18.99-10.49-8.24-25.67-6.42-33.91,4.07-8.24,10.49-6.42,25.67,4.07,33.91,8.76,6.88,21.09,6.88,29.85,0-5.83-4.58-9.23-11.58-9.22-18.99Z",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77,54.97v-.78h.34v-.16h-.8v.16h.32v.78h.15Zm1.55,0v-.94h-.24l-.28,.67-.28-.67h-.24v.94h.17v-.71l.26,.61h.18l.26-.61v.71h.17Z",
    style: {
      fill: "#f79e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08,40c0,13.34-10.81,24.15-24.15,24.15-5.41,0-10.67-1.82-14.93-5.17,10.49-8.24,12.31-23.43,4.07-33.91-1.19-1.51-2.55-2.88-4.07-4.07,10.49-8.24,25.67-6.43,33.91,4.06,3.35,4.26,5.17,9.51,5.17,14.93h0Z",
    style: {
      fill: "#f79e1b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card_mastercard.a79f4560ed77eaec67e3e48c60f6f992.svg";
export { ForwardRef as ReactComponent };